import { mtechnavi } from '~/shared/libs/clientsdk';
import { AppSaveWorker } from '..';
import { SystemNotificationSetting } from '../type';

export interface UpdateSystemNotificationSettingRequest {
  actionName: 'updateSystemNotificationSetting';
  request: SystemNotificationSetting;
}

// // システム通知先更新（送信）
export const updateSystemNotificationSetting = async (
  worker: AppSaveWorker,
  req: SystemNotificationSetting
) => {
  const getFullMethodName =
    'mtechnavi.api.survey.SurveySenderService/GetSurveyRequest';
  const updateFullMethodName =
    'mtechnavi.api.survey.SurveySenderService/UpdateSystemNotificationUsersInSurveyRequest';
  // // 依頼受信情報を取得
  const items = await worker.invokeListRequest<
    mtechnavi.api.survey.IGetSurveyRequestContentRequest,
    mtechnavi.api.survey.SurveyRequest
  >(getFullMethodName, {
    surveyRequestId: req.recordId,
  });
  if (items && items.length > 0) {
    const item = items[0];
    const users = item.systemNotificationUsers;

    // 追加ユーザーが渡された場合
    if (req.appendUser) {
      if (!users.find((user) => user.userId === req.appendUser?.userId)) {
        users.push(req.appendUser);
      }
      item.systemNotificationUsers = users;
    }
    // 削除ユーザーが渡された場合
    if (req.removeUser) {
      const deleteUsers = users.filter(
        (user) => user.userId !== req.removeUser?.userId
      );
      item.systemNotificationUsers = deleteUsers;
    }
    // 依頼受信情報を更新
    await worker.invokeListRequest<
      mtechnavi.api.survey.IUpdateSystemNotificationUsersInSurveyRequestRequest,
      mtechnavi.api.survey.SurveyRequest
    >(updateFullMethodName, {
      surveyRequestId: item.surveyRequestId,
      systemNotificationUsers: item.systemNotificationUsers,
      updatedAt: item.updatedAt,
    });
  }
};
